import { apiClient } from './api';

export interface Role {
  id: string;
  name: string;
  label: string;
  description?: string;
  hierarchy: number;
  isSystem: boolean;
  permissions: string[];
}

export interface Permission {
  id: string;
  name: string;
  resource: string;
  action: string;
  description?: string;
}

export interface RolesResponse {
  success: boolean;
  data: {
    roles: Role[];
  };
}

export interface PermissionsResponse {
  success: boolean;
  data: {
    permissions: Permission[];
  };
}

export interface CreateRoleData {
  name: string;
  label: string;
  description?: string;
  hierarchy: number;
  permissions: string[];
}

export interface UpdateRoleData {
  name?: string;
  label?: string;
  description?: string;
  hierarchy?: number;
  permissions?: string[];
}

export interface RoleResponse {
  success: boolean;
  data: {
    role: Role;
  };
}

export class RoleService {
  async getRoles(): Promise<Role[]> {
    const result = await apiClient.getRoles();
    return result.roles;
  }

  async getPermissions(): Promise<Permission[]> {
    const result = await apiClient.getPermissions();
    return result.permissions;
  }

  async createRole(data: CreateRoleData): Promise<Role> {
    const result = await apiClient.createRole(data);
    return result.role;
  }

  async updateRole(id: string, data: UpdateRoleData): Promise<Role> {
    const result = await apiClient.updateRole(id, data);
    return result.role;
  }

  async deleteRole(id: string): Promise<void> {
    await apiClient.deleteRole(id);
  }
}

export const roleService = new RoleService();
